import { type ProspectDto } from "@crowdcoursing/api/openapi";
import { DateTime } from "luxon";
import { useState } from "react";

export const useNoteSort = (notes: NonNullable<ProspectDto["notes"]>) => {
  const [sortNewestFirst, setSortNewestFirst] = useState(true);

  const sortNotes = (a: NonNullable<ProspectDto["notes"]>[number], b: NonNullable<ProspectDto["notes"]>[number]) => {
    const multiplier = sortNewestFirst ? 1 : -1;
    return (
      multiplier * (DateTime.fromISO(b.createdAt ?? "").toMillis() - DateTime.fromISO(a.createdAt ?? "").toMillis())
    );
  };

  const pinnedNotes = (notes?.filter((n) => n.pinned) ?? []).sort(sortNotes);
  const regularNotes = (notes?.filter((n) => !n.pinned) ?? []).sort(sortNotes);

  return {
    pinnedNotes,
    regularNotes,
    setSortNewestFirst,
    sortNewestFirst,
  };
};
